/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for next icon.
 *
 * @author Hari Gangadharan
 */
const ChevronPrev = props => (
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <path
      d="M13.749,17.6606035 C14.112,17.2486035
      14.076,16.6116035 13.662,16.2436035 L5.509,8.9996035
      L13.662,1.7566035 C14.077,1.3896035 14.113,0.752603504
      13.749,0.339603504 C13.383,-0.0763964961 12.751,-0.115396496
      12.338,0.252603504 L3.338,8.2476035 C3.123,8.4376035 3,8.7126035
      3,8.9996035 C3,9.2876035 3.123,9.5616035 3.338,9.7526035
      L12.338,17.7476035 C12.751,18.1156035 13.383,18.0766035
      13.749,17.6606035"
    />
  </SvgIcon>
);

export default ChevronPrev;



// WEBPACK FOOTER //
// ./src/js/icons/ChevronPrev.jsx